'use client'
import * as React from 'react'
import { ShareButton } from '@web/app/[locale]/clubhouse/[slug]/_components/action-buttons/share-button'
import { useSocialShareDialog } from '@repo/web-ui/ask-cf/contexts/social-share-dialog-context'
import { NEXT_PUBLIC_CF_URL } from '@web/utils/env'
import type { Project } from '../../page-client'
import { AppRoutes } from '@repo/web-utils/app-routes'
import { useFeedRoute } from '../../contexts/feed-route-context'

interface Props {
  //   upvotes: number
  //   discussionId: string
  //   discussionSlug: string
  size?: 'small' | 'regular'
  project: Project
}

export const ProjectShareButton = ({ size, project }: Props) => {
  const { openDialog } = useSocialShareDialog()
  const { basePath } = useFeedRoute()
  const detailsHref = `${NEXT_PUBLIC_CF_URL}${basePath}/${project?.postSlug}/`

  const handleClickShare = () => {
    openDialog(detailsHref, 'Share Project')
  }

  return <ShareButton size={size} onClick={handleClickShare} />
}
